import { AfterViewChecked, Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from './../input-base-react/input-base-react.component';

@Component({
  selector: 'app-input-text-react',
  templateUrl: './input-text-react.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextReactComponent),
      multi: true
    }
  ]
})

export class InputTextReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

  @Input() rows = 5;

  //#region .  LifeCycle Methods e Construtor
  constructor() {
    super();
  }

  // chama método ngOnInit da classe base e prepara valores de spans de validação
  ngOnInit(): void {
    super.ngOnInit();

    this.setAndUpdateValidators();
  }

  // chama método ngOnChanges da classe base e efetua o recarregamento de validadores.
  ngOnChanges(): void {
    super.ngOnChanges();

    this.setAndUpdateValidators();
  }

  //#endregion

}
